import type { AxiosError } from "axios";

export class PermissionDeniedError extends Error {
  readonly kind = "permission-denied" as const;
  readonly status = 403 as const;

  constructor(readonly requestError: AxiosError) {
    super("The authenticated staff user does not have permission for this operation");
    this.name = "PermissionDeniedError";
  }
}

export class MissingRefreshTokenError extends Error {
  readonly kind = "missing-refresh-token" as const;

  constructor() {
    super("Refresh token is not available");
    this.name = "MissingRefreshTokenError";
  }
}

export class InvalidSessionError extends Error {
  readonly kind = "session-invalid" as const;

  constructor(
    readonly status: 400 | 401 | 403,
    readonly refreshError: AxiosError,
  ) {
    super("The refresh token is no longer valid");
    this.name = "InvalidSessionError";
  }
}

export const isPermissionDeniedError = (error: unknown): error is PermissionDeniedError =>
  error instanceof PermissionDeniedError;

export const isInvalidSessionError = (
  error: unknown,
): error is InvalidSessionError => error instanceof InvalidSessionError;
